/* GG · Global · Age Gate
   Reads/writes a localStorage flag with expiry. The overlay is visible by
   default (fail-safe); this script hides it for confirmed visitors and
   wires the confirm/decline buttons. A companion inline head script
   (in theme.liquid) adds html.gg-age-ok before paint to avoid a flash. */
(function () {
  'use strict';
  var KEY = 'gg_age_ok';
  var root = document.documentElement;

  function isConfirmed() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return false;
      var exp = parseInt(raw, 10);
      if (isNaN(exp)) return true; // legacy truthy value = confirmed
      return exp === 0 || exp > Date.now();
    } catch (e) {
      return false;
    }
  }

  function confirm(days) {
    try {
      var exp = days > 0 ? Date.now() + days * 86400000 : 0; // 0 = session-only-ish (persists)
      localStorage.setItem(KEY, String(exp));
    } catch (e) {}
    root.classList.add('gg-age-ok');
    root.classList.remove('gg-age-locked');
  }

  function init() {
    var gate = document.querySelector('[data-gg-age-gate]');
    if (!gate) return;

    if (isConfirmed()) {
      root.classList.add('gg-age-ok');
      return;
    }

    // Lock scroll while gate is open.
    root.classList.add('gg-age-locked');

    var days = parseInt(gate.getAttribute('data-remember-days'), 10) || 0;

    var confirmBtn = gate.querySelector('[data-gg-age-confirm]');
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        confirm(days);
      });
    }

    // Decline is a normal link (redirect); just ensure scroll stays locked.
    var declineBtn = gate.querySelector('[data-gg-age-decline]');
    if (declineBtn) {
      declineBtn.addEventListener('click', function () {
        root.classList.add('gg-age-locked');
      });
    }

    // Keep focus trapped-ish: move focus into the dialog.
    if (confirmBtn) {
      try { confirmBtn.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
